<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordoglo/svgGlo16bg.svg" />

    <label
      class="checkMarkContainer-a"
      style="left: 293px; top: 119px; position: absolute"
      >Una Sílaba
      <input type="checkbox" 
      ref="a1" 
      v-on:click="saveOption('silabasCangrejo', 'a1')" 
      :onload="loadOption('silabasCangrejo', 'a1')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 357px; top: 119px; position: absolute"
      >Dos Sílabas
      <input type="checkbox" 
      ref="a2" 
      v-on:click="saveOption('silabasCangrejo', 'a2')" 
      :onload="loadOption('silabasCangrejo', 'a2')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 420px; top: 119px; position: absolute"
      >Tres Sílabas
      <input type="checkbox" 
      ref="a3" 
      v-on:click="saveOption('silabasCangrejo', 'a3')" 
      :onload="loadOption('silabasCangrejo', 'a3')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 483px; top: 119px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox" 
      ref="a4" 
      v-on:click="saveOption('silabasCangrejo', 'a4')" 
      :onload="loadOption('silabasCangrejo', 'a4')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 546px; top: 119px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox" 
      ref="a5" 
      v-on:click="saveOption('silabasCangrejo', 'a5')" 
      :onload="loadOption('silabasCangrejo', 'a5')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 610px; top: 119px; position: absolute"
      >Seis Sílabas
      <input type="checkbox" 
      ref="a6" 
      v-on:click="saveOption('silabasCangrejo', 'a6')" 
      :onload="loadOption('silabasCangrejo', 'a6')"
      >
      <span class="checkmark-a"></span>
    </label>

    <label
      class="checkMarkContainer-a"
      style="left: 291px; top: 359px; position: absolute"
      >Una Sílaba
      <input type="checkbox" 
      ref="c1" 
      v-on:click="saveOption('silabaPato', 'c1')" 
      :onload="loadOption('silabaPato', 'c1')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 355px; top: 359px; position: absolute"
      >Dos Sílabas
      <input type="checkbox" 
      ref="c2" 
      v-on:click="saveOption('silabaPato', 'c2')" 
      :onload="loadOption('silabaPato', 'c2')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 418px; top: 359px; position: absolute"
      >Tres Sílabas
      <input type="checkbox" 
      ref="c3" 
      v-on:click="saveOption('silabaPato', 'c3')" 
      :onload="loadOption('silabaPato', 'c3')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 481px; top: 359px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox" 
      ref="c4" 
      v-on:click="saveOption('silabaPato', 'c4')" 
      :onload="loadOption('silabaPato', 'c4')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 544px; top: 359px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox" 
      ref="c5" 
      v-on:click="saveOption('silabaPato', 'c5')" 
      :onload="loadOption('silabaPato', 'c15')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 608px; top: 359px; position: absolute"
      >Seis Sílabas
      <input type="checkbox" 
      ref="c6" 
      v-on:click="saveOption('silabaPato', 'c6')" 
      :onload="loadOption('silabaPato', 'c6')"
      >
      <span class="checkmark-a"></span>
    </label>

    <label
      class="checkMarkContainer-a"
      style="left: 291px; top: 599px; position: absolute"
      >Una Sílaba
      <input type="checkbox" 
      ref="b1" 
      v-on:click="saveOption('silabaMosca', 'b1')" 
      :onload="loadOption('silabaMosca', 'b1')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 355px; top: 599px; position: absolute"
      >Dos Sílabas
      <input type="checkbox" 
      ref="b2" 
      v-on:click="saveOption('silabaMosca', 'b2')" 
      :onload="loadOption('silabaMosca', 'b2')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 418px; top: 599px; position: absolute"
      >Tres Sílabas
      <input type="checkbox" 
      ref="b3" 
      v-on:click="saveOption('silabaMosca', 'b3')" 
      :onload="loadOption('silabaMosca', 'b3')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 481px; top: 599px; position: absolute"
      >Cuatro Sílabas
      <input type="checkbox" 
      ref="b4" 
      v-on:click="saveOption('silabaMosca', 'b4')" 
      :onload="loadOption('silabaMosca', 'b4')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 544px; top: 599px; position: absolute"
      >Cinco Sílabas
      <input type="checkbox" 
      ref="b5" 
      v-on:click="saveOption('silabaMosca', 'b5')" 
      :onload="loadOption('silabaMosca', 'b5')"
      >
      <span class="checkmark-a"></span>
    </label>
    <label
      class="checkMarkContainer-a"
      style="left: 608px; top: 599px; position: absolute"
      >Seis Sílabas
      <input type="checkbox" 
      ref="b6" 
      v-on:click="saveOption('silabaMosca', 'b6')" 
      :onload="loadOption('silabaMosca', 'b6')"
      >
      <span class="checkmark-a"></span>
    </label>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <img id="crab" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo8Crab.svg">
    <img id="duck" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo7DuckFlip.svg">
    <img id="fly" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo7Fly.svg">
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 41px;
  top: 78px;
}
#inputField01 {
  position: absolute;
  width: 160px;
  height: 50px;
  left: 745px;
  top: 125px;
  background-color: #D2D1C2;
}
#inputField02 {
  position: absolute;
  width: 160px;
  height: 50px;
  left: 745px;
  top: 365px;
  background-color: #D2D1C2;
}
#inputField03 {
  position: absolute;
  width: 160px;
  height: 50px;
  left: 745px;
  top: 605px;
  background-color: #D2D1C2;
}
#crab{
  position: absolute;
  left: 41px;
  top: 106px;
}
#duck{
  position: absolute;
  left: 86px;
  top: 303px;
}
#fly{
  position: absolute;
  left: 93px;
  top: 550px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, option){
        return `${this.$parent.type}-${this.$parent.page}-${name}-${option}`
      },
      async loadOption(name, option) {
        var id = this.dbId(name, option);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[option].checked=value.option;

        console.log("option loaded: " + id + ", " + value.option);
      },
      saveOption(name, option) {
        var id = this.dbId(name, option);
        console.log(option);
        var value = this.$refs[option].checked;

        this.$db.options.put({
              id: id,
              option: value
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + value);
      }
    },
    mounted(){

    }
  }
</script>